var address = $('.address-contact__text.is-address');
var maps = $('.maps__item');

address.click(function (event) {
    address.removeClass('is-active');
    maps.removeClass('is-active');
    $(this).addClass('is-active');
    $(maps[this.dataset.tab - 1]).addClass('is-active');
});

var form = $('form[id^="mktoForm_"]');

form.on('change', function (event) {
    var stateSelect = document.getElementById("State");

    if (stateSelect) {
        if (stateSelect.value == '') {
            if (stateSelect.options[0].value !== '') {
                var placeholderOption = document.createElement("option");
                placeholderOption.text = 'Select';
                placeholderOption.value = '';
                stateSelect.add(placeholderOption, stateSelect.options[0]);
            }
        }
    }
});

$(document).ready(() => {
    const headerHeight = $(".site-header").outerHeight();
    const utilityNavHeight = $(".customer-utility-nav").outerHeight();
    const footerHeight = $(".site-footer").outerHeight();
    const minHeight = $(window).height() - (headerHeight + utilityNavHeight + footerHeight);

    $(".contact-us-page").css("min-height", minHeight + "px");
});